/** @prettier */
import { List, Map } from 'immutable';

import { SET_RELATED_EVENTS } from './actions';

export const initialState = new Map();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_RELATED_EVENTS: {
      const { competition, events } = payload;

      return state.set(competition, new List(events.map((event) => event.id)));
    }
    default: {
      return state;
    }
  }
};
